import apiClient from './axiosClient';

export const getSalesByDateRange = (startDate, endDate) => apiClient.get('/sales/', {
  params: {
    start_date: startDate,
    end_date: endDate,
  },
});